
import { useRequestServiceCodeVM } from "presentation/hook/RequestServiceCode/useRequestServiceCodeVM";
import { useRequestServiceCodeTracked } from "presentation/store/RequestServiceCode/RequestServiceCodeProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import RequestServiceCodeEditPanel from "./RequestServiceCodeEditPanel";
import RequestServiceCodeTablePanel from "./RequestServiceCodeTablePanel";

export const RequestServiceCodeMaintenance: React.FC = () => {
    const [requestServiceCodeState] = useRequestServiceCodeTracked();
    const requestServiceCodeStateVM = useRequestServiceCodeVM();
    const { isShowEditPanel } = requestServiceCodeState;
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    requestServiceCodeStateVM.onSearch(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {
                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            setIsLoading(false);
        });

    }, [requestServiceCodeStateVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>
            {isShowEditPanel && <RequestServiceCodeEditPanel />}
            {!isShowEditPanel && <SliderPanel
                isOpen={true}
                leftSectionWidth={'100%'}
                rightSectionWidth={"0%"}
                draggable={false}
                leftChildren={<RequestServiceCodeTablePanel />}
            />}
        </div>
    </>
}